import React, { useState, useCallback } from "react";
import { useActions, useApiActions, useList, useListReload } from "state/hooks";
import { useEntity } from "state/hooks/useEntity";
import useFetch from "state/hooks/useFetch";
import { createCallback } from "state/actions/create";
import { submitOneCallback, removeCallback } from "state/actions/api";
import { FormContainer } from "playground/cms/Form/FormContainer";
import Button from "components/Button";
import Preloader from "components/Preloader";
import { CronItem } from "./CronItem";
import { CronForm } from "./CronForm";
import "./style.css";

const CRON_TYPE = "cms.sync-task-cron";

export function CronManager() {
    const { id: taskId } = useEntity();
    const cronUrl = `cms/sync-tasks/${taskId}/cron`;
    const list = taskId;

    const [editId, setEditId] = useState(null);

    const isPending = useFetch({
        type: CRON_TYPE,
        list,
        url: cronUrl,
    });

    const [onReload] = useListReload(CRON_TYPE, list);
    const { items } = useList(CRON_TYPE, list);

    const { onCreate } = useActions({
        onCreate: createCallback,
    });

    const { onSubmit, onRemove } = useApiActions({
        onSubmit: submitOneCallback,
        onRemove: removeCallback,
    });

    const handleCreate = useCallback(() => {
        onCreate(
            (data) => setEditId(data.id),
            CRON_TYPE,
            { cron_schedule: "*/5 * * * *", active: true },
            list
        );
    }, [onCreate, list]);

    const handleSubmit = useCallback(
        (cronId) => {
            onSubmit(null, CRON_TYPE, cronId, `${cronUrl}/${cronId}`);
        },
        [onSubmit, cronUrl]
    );

    const handleDelete = useCallback(
        (cronId) => {
            onRemove(() => null, CRON_TYPE, cronId, `${cronUrl}/${cronId}`);
            if (editId === cronId) setEditId(null);
        },
        [onRemove, cronUrl, editId]
    );

    const handleCloseEdit = useCallback(() => setEditId(null), []);

    return (
        <div className={"cron-manager rows gap-sm"}>
            <Preloader visible={isPending} />
            {items &&
                items.map((cronId) => (
                    <FormContainer
                        key={cronId}
                        type={CRON_TYPE}
                        id={cronId}
                        disableFetch
                        onSave={() => handleSubmit(cronId)}
                        onSubmit={() => handleSubmit(cronId)}
                    >
                        {editId === cronId ? (
                            <CronForm onClose={handleCloseEdit} />
                        ) : (
                            <CronItem
                                onEdit={() => setEditId(cronId)}
                                onDelete={() => handleDelete(cronId)}
                            />
                        )}
                    </FormContainer>
                ))}
            <div>
                <Button size={"small"} onClick={handleCreate}>
                    + Dodaj harmonogram
                </Button>
            </div>
        </div>
    );
}

CronManager.defaultProps = {};

export default CronManager;